import { FC, MouseEvent } from "react";
import { FolderItemProps } from "../../types";
import { useBucketContext } from "context/bucket";
import { DottedMenu } from "../dotted-menu";

export const FolderListItem: FC<FolderItemProps> = (props) => {
  const { item, showRemoveModal, showRenameModal, showMoveModal } = props;
  const { name, fullPath } = item;
  const { fetchHomePageData } = useBucketContext();

  const handleItemClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    fetchHomePageData(fullPath);
  };

  const handleMoveAction = async () => {
    showMoveModal({ name, path: fullPath, isFolder: true });
  };

  const handleRenameAction = async () =>
    showRenameModal({ name: name, path: fullPath, isFolder: true });

  const handleDeleteAction = async () =>
    showRemoveModal({ name, path: fullPath, isFolder: true });

  return (
    <>
      <li className="list-group-item px-0 d-flex justify-content-between align-items-start">
        <div
          className="text-light d-flex align-items-center gap-2"
          onClick={() => handleItemClick}
        >
          <i className="bi bi-folder-fill fs-3 align-middle text-primary" />
          <span className="text-truncate">{name}</span>
        </div>
        <div>
          <DottedMenu
            id={name}
            actions={[
              { label: "Sposta", action: handleMoveAction },
              { label: "Rinomina", action: handleRenameAction },
              { label: "Elimina", action: handleDeleteAction },
            ]}
          />
        </div>
      </li>
    </>
  );
};
